var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { class: ["content bg-light", { expanded: !_vm.isSidebarOpen }] },
          [
            _c(
              "div",
              [
                _c("b-container", { attrs: { fluid: "" } }, [
                  _c(
                    "div",
                    { staticClass: "content-title" },
                    [
                      _c("b-row", [_c("h1", [_vm._v("Documentation & Help")])]),
                      _vm._v(" "),
                      _c("b-row", [
                        _c("span", { staticClass: "content-subtitle" }, [
                          _vm._v(
                            "\n                Complete guide to using the Digital Credit Transfer Sandbox\n              "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "nav-container" },
                  [
                    _c(
                      "b-col",
                      {
                        class: { active: _vm.showPanel === "overview" },
                        on: {
                          click: function ($event) {
                            _vm.showPanel = "overview"
                          },
                        },
                      },
                      [_vm._v("Overview")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        class: { active: _vm.showPanel === "features" },
                        on: {
                          click: function ($event) {
                            _vm.showPanel = "features"
                          },
                        },
                      },
                      [_vm._v("Features")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        class: { active: _vm.showPanel === "workflows" },
                        on: {
                          click: function ($event) {
                            _vm.showPanel = "workflows"
                          },
                        },
                      },
                      [_vm._v("Workflows")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        class: { active: _vm.showPanel === "glossary" },
                        on: {
                          click: function ($event) {
                            _vm.showPanel = "glossary"
                          },
                        },
                      },
                      [_vm._v("Glossary")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        class: { active: _vm.showPanel === "faq" },
                        on: {
                          click: function ($event) {
                            _vm.showPanel = "faq"
                          },
                        },
                      },
                      [_vm._v("FAQ")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showPanel === "features"
                  ? _c(
                      "div",
                      _vm._l(_vm.features, function (feature, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "card p-6" },
                          [
                            _c("div", { staticClass: "flex-between" }, [
                              _c("span", { staticClass: "text-title" }, [
                                _vm._v(_vm._s(feature.title)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-light",
                                  on: {
                                    click: function ($event) {
                                      return _vm.navigate("/" + feature.link)
                                    },
                                  },
                                },
                                [
                                  _vm._v("\n                Open "),
                                  _c("i", {
                                    staticClass: "fa-light fa-arrow-right",
                                  }),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-subtle" }, [
                              _vm._v(_vm._s(feature.body)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex-between my-3-1 clickable",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleDetails(feature.title)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "text-bold" }, [
                                  _vm._v("View Details"),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  class: [
                                    "fa-light fa-duotone",
                                    _vm.seeDetails === feature.title
                                      ? "fa-angle-up"
                                      : "fa-angle-down",
                                  ],
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.seeDetails === feature.title
                              ? _c(
                                  "div",
                                  [
                                    _c("span", { staticClass: "text-bold" }, [
                                      _vm._v("Quick Tips"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      _vm._l(
                                        feature.details,
                                        function (detail, i) {
                                          return _c("li", { key: i }, [
                                            _vm._v(_vm._s(detail)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-bold" }, [
                                      _vm._v("Key Points"),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(feature.points, function (point, i) {
                                      return _c("div", { key: i }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-bold my-05 block",
                                          },
                                          [_vm._v(_vm._s(point))]
                                        ),
                                      ])
                                    }),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPanel === "workflows"
                  ? _c(
                      "div",
                      _vm._l(_vm.workflows, function (workflow, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "card p-6" },
                          [
                            _c("span", { staticClass: "workflow-title" }, [
                              _c("i", {
                                staticClass:
                                  "fal fa-bolt icon-md icon-purple flex-center icon-rounded",
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(workflow.title) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(workflow.items, function (item, i) {
                              return _c(
                                "div",
                                { key: i, staticClass: "workflow-item" },
                                [
                                  _c("span", { staticClass: "workflow-step" }, [
                                    _vm._v(_vm._s(i + 1)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-subtle" }, [
                                    _vm._v(_vm._s(item)),
                                  ]),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPanel === "glossary"
                  ? _c(
                      "div",
                      { staticClass: "card p-6 glossary-grid" },
                      _vm._l(_vm.glossary, function (t, index) {
                        return _c("div", { key: index, staticClass: "grid" }, [
                          _c("span", { staticClass: "text-bold text-dark" }, [
                            _vm._v(_vm._s(t.title)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-subtle" }, [
                            _vm._v(_vm._s(t.body)),
                          ]),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPanel === "faq"
                  ? _c(
                      "div",
                      _vm._l(_vm.faqs, function (faq, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "card p-6 faq-card" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "faq-header clickable",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleDetails(faq.title)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "faq-title" }, [
                                  _c("i", {
                                    staticClass:
                                      "fa-regular fa-circle-question text-primary",
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-lg" }, [
                                    _vm._v(_vm._s(faq.title)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  class: [
                                    "fa-light fa-duotone",
                                    _vm.seeDetails === faq.title
                                      ? "fa-angle-up"
                                      : "fa-angle-down",
                                  ],
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.seeDetails === faq.title
                              ? _c("span", { staticClass: "faq-body" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(faq.body) +
                                      "\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPanel === "overview"
                  ? _c("div", [
                      _c("div", { staticClass: "card p-6 my-2" }, [
                        _c("div", { staticClass: "flex-start flex-gap-1" }, [
                          _c("i", {
                            staticClass:
                              "fa-light fa-home icon-lg icon-blue flex-center icon-rounded",
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "grid" }, [
                            _c("span", { staticClass: "text-lg text-dark" }, [
                              _vm._v(
                                "\n                  Welcome to the Digital Credit Transfer Sandbox\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-subtle" }, [
                              _vm._v(
                                "\n                  This sandbox environment allows you to test and understand the complete lifecycle of order creation,\n                  payment processing, and automated reconciliation.\n                "
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "section-title" }, [
                        _vm._v("Core Concepts"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "grid-2 grid-gap-2 my-1" },
                        _vm._l(_vm.concepts, function (concept, i) {
                          return _c(
                            "div",
                            { key: i, staticClass: "card p-6 card-shadow" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-start flex-gap-1" },
                                [
                                  _c("div", [
                                    _c("i", {
                                      class: [concept.icon, "flex-center"],
                                      staticStyle: {
                                        height: "2.5rem",
                                        width: "2.5rem",
                                        "border-radius": "0.5rem",
                                        "font-size": "1.1rem",
                                      },
                                      style: concept.style,
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "grid" }, [
                                    _c("span", { staticClass: "text-lg" }, [
                                      _vm._v(_vm._s(concept.title)),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-subtle" }, [
                                      _vm._v(_vm._s(concept.body)),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "section-title" }, [
                        _vm._v("Getting Started by Role"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "grid-3 grid-gap-2 my-1" },
                        _vm._l(_vm.roles, function (role, i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticClass: "card p-6 role-card grid",
                              staticStyle: { gap: "2rem" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "btn-empty", style: role.badge },
                                [_vm._v(_vm._s(role.name))]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(role.subtitle))]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                _vm._l(role.items, function (item, j) {
                                  return _c("li", { key: j }, [
                                    _vm._v(_vm._s(item)),
                                  ])
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-light",
                                  on: {
                                    click: function ($event) {
                                      return _vm.navigate(role.link)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(role.cta) +
                                      " "
                                  ),
                                  _c("i", {
                                    staticClass: "fa-light fa-arrow-right",
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-container p-6" }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex-start flex-gap-1",
                            staticStyle: { color: "#000" },
                          },
                          [
                            _c("div", [
                              _c("i", {
                                staticClass:
                                  "fa-light fa-circle-exclamation icon-lg icon-primary flex-center icon-rounded",
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "grid-gap-05 grid" },
                              [
                                _c("span", { staticClass: "text-xl" }, [
                                  _vm._v("Critical Business Rules"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.rules, function (rule, i) {
                                  return _c(
                                    "span",
                                    { key: i, staticClass: "rule" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-light fa-circle-check text-success",
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "text-bold" }, [
                                        _vm._v(_vm._s(rule.bold)),
                                      ]),
                                      _vm._v(
                                        _vm._s(rule.text) + "\n                "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }